import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// value: "all" or comma-separated values; options: [{ value, label }]
export function MultiSelect({ value, onValueChange, options = [], allLabel, searchPlaceholder = "Cerca…", testid, className }) {
  const [open, setOpen] = useState(false);
  const sel = !value || value === "all" ? [] : value.split(",");
  const toggle = (v) => {
    const next = sel.includes(v) ? sel.filter((x) => x !== v) : [...sel, v];
    onValueChange(next.length ? next.join(",") : "all");
  };
  const label = !sel.length ? allLabel
    : sel.length === 1 ? (options.find((o) => o.value === sel[0])?.label || sel[0]) : `${sel.length} selezionati`;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" data-testid={testid}
          className={cn("justify-between font-normal", sel.length && "border-primary/60 text-foreground", className)}>
          <span className="truncate">{label}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>Nessun risultato</CommandEmpty>
            <CommandGroup>
              <CommandItem value={`__all__ ${allLabel}`} onSelect={() => onValueChange("all")} data-testid={testid ? `${testid}-option-all` : undefined}>
                <Check className={cn("mr-2 h-4 w-4", !sel.length ? "opacity-100" : "opacity-0")} />{allLabel}
              </CommandItem>
              {options.map((o) => (
                <CommandItem key={o.value} value={`${o.label} ${o.value}`} onSelect={() => toggle(o.value)}
                  data-testid={testid ? `${testid}-option-${o.value}` : undefined}>
                  <span className={cn("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary",
                    sel.includes(o.value) ? "bg-primary text-primary-foreground" : "opacity-60")}>
                    {sel.includes(o.value) && <Check className="h-3 w-3" />}
                  </span>
                  <span className="truncate">{o.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
